export * from '@primeuix/themes/material/inputnumber';
export { default } from '@primeuix/themes/material/inputnumber';
